import { Component, ElementRef, inject, input, OnInit, signal } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TreeModule } from 'primeng/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { TreeService } from 'src/app/services/tree.service';
import { LoggedInUserService } from 'src/app/services/auth/logged-in-user-service';
import { ModelType } from '@shared/constants/model-type.enum';
import { TreeData } from '@models/tree-data.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cvx-aside-left',
  imports: [TreeModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule, CommonModule],
  templateUrl: './cvx-aside-left.component.html',
  styleUrl: './cvx-aside-left.component.scss',
  standalone: true
})
export class CvxAsideLeftComponent implements OnInit {
  private _el: ElementRef = inject(ElementRef);
  private router: Router = inject(Router);
  private treeService: TreeService = inject(TreeService);
  private loggedInUserService: LoggedInUserService = inject(LoggedInUserService);

  pExpanded = input<boolean>(false);
  message: string = '';
  protected selectedDataHierarchy!: TreeNode;
  protected panelVisible = signal(false);
  dataTree = signal<TreeNode<TreeData>[]>([]);
  loading: boolean = false; 
  ngOnInit() {
    this.loggedInUserService.currentUser$.subscribe((data: any) => {
      if (data && data.roles ) {        
        const userRoles = data.roles.filter((role: string) => Object.values(ModelType).includes(role)) as [];
        if (userRoles.length > 0) {       
          this.getTree();
        }
        else {
          //no rules found
          this.message = 'You are not authorized to view this Models';
          this.dataTree.set([]);
        }
      }
    });
    this.panelVisible.set(this.pExpanded());
    this.togglePanel(this.panelVisible(), false);        
    
  }

  getTree(){
    this.loading = true;
    this.treeService.getTreeData().subscribe({
      next: (data: any) => {
        this.dataTree.set(data);
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error fetching tree data', err);
        this.message = 'No Models found';
        this.dataTree.set([]);
        this.loading = false;
      }
    });
  }

  togglePanel(expanded?: boolean | null, withTransition: boolean = true) {

    const panel = this._el.nativeElement.querySelector('.cvx-slide-panel');

    if (panel) {
      if (!withTransition) {
        panel.classList.add('cvx-no-transition');
      } else {
        panel.classList.remove('cvx-no-transition');
      }
    }

    if (expanded === undefined || expanded === null) {
      this.panelVisible.set(!this.panelVisible());
    }
    else {
      this.panelVisible.set(expanded);
    }

    if (panel) {
      if (this.panelVisible()) {
        panel.classList.remove('cvx-hidden-content');
      }
      else {
        panel.classList.add('cvx-hidden-content');
      }
    }
  }

  expandAll() {
    this.dataTree().forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll() {
    this.dataTree().forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  private expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  nodeExpand(event: any) {
      //this.messageService.add({ severity: 'success', summary: 'Node Expanded', detail: event.node.label });
  }

  nodeCollapse(event: any) {
      //this.messageService.add({ severity: 'warn', summary: 'Node Collapsed', detail: event.node.label });
  }

  nodeSelect(event: any) {
    if(event.node.parent != null){
      const parent = event.node.parent;
      const label = event.node.data.modelType as keyof typeof ModelType;
      const modelType = ModelType[label];

      if(parent.parent != null){
        this.router.navigate(['/model-view'], {queryParams: {modelType: modelType, treeId: event.node.key, label: event.node.label, projectId: event.node.data.projectId, parentLabel: event.node.parent.label }});
      }else{
        this.router.navigate(['/folder-view'], {queryParams: {modelType: modelType, treeId: event.node.key, label: event.node.label, projectId: event.node.data.projectId }});
      }
    }
  }

  nodeUnselect(event: any) {
      //this.messageService.add({ severity: 'info', summary: 'Node Unselected', detail: event.node.label });
  }
}
